var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9766 3.88768C11.1837 3.88768 11.3516 4.05556 11.3516 4.26268V11.3877C11.3516 11.5948 11.1837 11.7627 10.9766 11.7627H3.85156C3.64445 11.7627 3.47656 11.5948 3.47656 11.3877V4.26268C3.47656 4.05556 3.64445 3.88768 3.85156 3.88768H10.9766ZM9.75781 5.48143H5.07031V10.1689H9.75781V5.48143ZM21.3203 7.53657C21.4667 7.683 21.4667 7.92045 21.3203 8.06689L17.0776 12.3095C16.9312 12.456 16.6938 12.456 16.5473 12.3095L12.3047 8.06689C12.1583 7.92045 12.1583 7.683 12.3047 7.53657L16.5474 3.29391C16.6938 3.14747 16.9312 3.14747 17.0777 3.29391L21.3203 7.53657ZM19.3316 7.80171L16.8125 5.28268L14.2934 7.80174L16.8125 10.3208L19.3316 7.80171ZM10.9766 13.2627C11.1837 13.2627 11.3516 13.4306 11.3516 13.6377V20.7627C11.3516 20.9698 11.1837 21.1377 10.9766 21.1377H3.85156C3.64445 21.1377 3.47656 20.9698 3.47656 20.7627V13.6377C3.47656 13.4306 3.64445 13.2627 3.85156 13.2627H10.9766ZM9.75781 14.8564H5.07031V19.5439H9.75781V14.8564ZM20.3516 13.2627C20.5587 13.2627 20.7266 13.4306 20.7266 13.6377V20.7627C20.7266 20.9698 20.5587 21.1377 20.3516 21.1377H13.2266C13.0194 21.1377 12.8516 20.9698 12.8516 20.7627V13.6377C12.8516 13.4306 13.0194 13.2627 13.2266 13.2627H20.3516ZM19.1328 14.8564H14.4453V19.5439H19.1328V14.8564Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/product.1a7013aec77d00be494259c0ddab7fe1.svg";
export { ForwardRef as ReactComponent };